module.exports = __webpack_public_path__ + "img/ai-sample-appendix.65c96668.webp";